import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { Card } from '@/components/sections/Card';
import BreadcrumbPageHeader from '@/layouts/BreadcrumbPageHeader';
import { Container } from '@/layouts/main/Main';
import { FunctionComponent } from 'react';

interface SubscriptionsPageProps {}

const SubscriptionsPage: FunctionComponent<SubscriptionsPageProps> = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Subscriptions',
      to: ''
    }
  ];

  return (
    <>
      <BreadcrumbPageHeader breadcrumbs={breadcrumbs}>
        <div className="flex justify-between gap-5 items-center font-bold">
          <h3 className="text-3xl">Subscriptions</h3>
        </div>
      </BreadcrumbPageHeader>
      <div className="flex-1 overflow-y-auto">
        <Container animate="pop" className="w-full py-8">
          <Card className="px-12 py-6">
            <ol className="list-decimal orderedListDecimalBrackets space-y-5">
              <li>
                <div className="space-y-2">
                  <p className="text-lg font-semibold">Device Fee - £75</p>
                  <p>Included:</p>
                  <ul className="pl-5 list-disc">
                    <li>Enrolment into Intune/ABM</li>
                    <li>Delivery (insured) of the device and any associated peripherals</li>
                    <li>Collection of the device up to 40 months</li>
                    <li>Processing of the device and data wipe at end-of-lifecycle</li>
                  </ul>
                </div>
              </li>
              <li className="space-y-10">
                <div className="space-y-2">
                  <p className="text-lg font-semibold">Platform License - £4.25 monthly / per user</p>
                  <p className="font-medium">What does this 'take off your plate' as a technology provider?</p>
                  <ul className="pl-5 list-disc">
                    <li>Quoting and sales engagement</li>
                    <li>Purchasing</li>
                    <li>Logistics handling - goods in/out/packing and packing materials</li>
                    <li>Warehousing and goods insurance</li>
                    <li>
                      Warranty Handling - logistics, handling the repair, classification, inventory policy management,
                      Q&A
                    </li>
                    <li>
                      An asset register which assigns all devices to individual users. You have the full picture to
                      manage your customers estate, drive tech refreshes and give reporting to your customers.
                    </li>
                    <li>Single pane of glass to manage everything</li>
                  </ul>
                </div>
                <div className="space-y-2">
                  <p className="text-lg font-semibold">
                    What does it deliver aside from 'taking things off your plate'?
                  </p>
                  <ul className="pl-5 list-disc">
                    <li>
                      Full platform access - Customer facing ecommerce self-service platform, you can brand as you!
                    </li>
                    <li>
                      MSP has full control to administer customer orders should the customer not wish to self-serve.
                    </li>
                    <li>Create bundles from standardised products, streamlining the ordering process</li>
                    <li>Reduces helpdesk support costs through product standardisation</li>
                    <li>
                      Access our basic-better-best range for next day delivery including our advanced device replacement
                      warranty included.
                    </li>
                    <li>Access our managed inventory model for larger clients</li>
                    <li>Deliver a superior experience to your customers.</li>
                    <li>Automated invoicing to your Xero coming soon.</li>
                  </ul>
                </div>
                <div className="space-y-2">
                  <p className="text-lg font-semibold">Access to chargeable services</p>
                  <ul className="pl-5 list-disc">
                    <li>Leavers/off-boarding Service - £95</li>
                    <ul className="pl-14 list-[circle]">
                      <li>Send packaging and instructions</li>
                      <li>Repatriate the device</li>
                      <li>Unenrolment, wipe/reinstall OS ready for new deployment</li>
                      <li>Process according to customer life-cycle-policies</li>
                      <li>Includes storage until redeployment or liquidation</li>
                      <li>Update asset register</li>
                    </ul>
                    <li>
                      Logistics-as-a-Service - Book deliveries and collections easily using our easy to complete single
                      page form. *coming soon
                    </li>
                  </ul>
                </div>
              </li>
            </ol>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default SubscriptionsPage;
